module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.value))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-058be9f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SimpleText.vue
// module id = 517
// module chunks = 1